import {
  CircularProgress,
  CircularProgressLabel,
  CircularProgressProps,
  Tooltip,
  useMediaQuery,
} from "@chakra-ui/react";

interface ICircularProps extends CircularProgressProps {
  valueThickness?: string | number;
  isAiScore?: boolean;
}

const JobCircularScore = ({
  color,
  value,
  thickness = "8px",
  valueThickness = 16,
  size = "60px",
  isAiScore = false,
  ...rest
}: ICircularProps): JSX.Element => {
  const [circleSize] = useMediaQuery("(max-width:500px)");
  const score = value?.toString();
  const preferenceToolTip = `The preferences you gave us suggest you prefer this job to ${
    score as string
  }% of other jobs scored.`;
  const aiToolTip = `You have a higher probability of success at this job compared with ${
    score as string
  }% of other jobs scored.`;
  return (
    <>
      <Tooltip
        label={isAiScore ? aiToolTip : preferenceToolTip}
        placement="bottom-start"
        hasArrow
      >
        <CircularProgress
          value={value}
          thickness={thickness}
          color={color}
          size={circleSize ? "40px" : size}
          {...rest}
          sx={{
            "& .chakra-progress__indicator": {
              strokeWidth: valueThickness,
            },
          }}
        >
          {!Number.isNaN(value) && (
            <CircularProgressLabel>{value}</CircularProgressLabel>
          )}
        </CircularProgress>
      </Tooltip>
    </>
  );
};

export default JobCircularScore;
